export default __webpack_public_path__ + "static/media/Refresh Data.382918c3.svg";